import React from 'react';

const Footer = () => {
  return (
    <div className='max-w-[1200px] sm:h-[150px] p-12 flex justify-between mx-auto'>
    <span className='primary-color text-3xl'>Likhitha Rai</span>
    <p className='text-gray-600'>likhitharai.lr12@gmail.com <br /> +91-7259137125 <br/>Made with ❤️ by Likhitha</p>
      
    </div>
  )
}

export default Footer;
